import { useEffect } from 'react';
import { businessClientActions, businessClientSelectors } from '../';
import { useSelector, useDispatch } from 'react-redux';

const useBusinessClients = () => {
  const businessClients = useSelector(state =>
    businessClientSelectors.getBusinessClientListTransformed(state),
  );
  const dispatch = useDispatch();
  // eslint-disable-next-line no-empty-function
  useEffect(() => {
    if (businessClients.length < 1) {
      dispatch(businessClientActions.fetchGridList({}));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [businessClients.length]);

  return businessClients;
};

export default useBusinessClients;
